module.exports = __webpack_public_path__ + "static/media/icon-close.1a297cff.svg";